import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/client";
import {
  Button,
  Column,
  Form,
  Icon,
  Modal,
  Notification,
  Row,
  Upload,
} from "@cea/ui-kit";

import Alert from "../../../components/NavigationAlert";
import { getNotification, imageUploader } from "../../../utils";
import { CREATE_ESS_STPR_FILE } from "../../../queries/miServices";
import { useCallbackPrompt } from "../../../hooks";

const ReportUploadForm = ({ formInstance }) => (
  <Form
    form={formInstance}
    initialValues={{}}
    layout="vertical"
    requiredMark={true}
  >
    <Row>
      <Column span={24}>
        <Form.Item
          name="link"
          label="Upload File"
          rules={[{ required: true, message: "File is required" }]}
          valuePropName="fileList"
          getValueFromEvent={(event) => event?.fileList}
        >
          <Upload.Dragger
            name="link"
            beforeUpload={(_, __) => false}
            multiple
            listType="text"
            showUploadList={{
              showRemoveIcon: true,
              removeIcon: (
                <Icon
                  name="delete"
                  size={14}
                  onClick={(e) => console.log(e, "custom removeIcon event")}
                />
              ),
            }}
          >
            <div className="flex items-center justify-center w-full mb-4">
              <Icon name="upload" color="var(--primary-theme)" size={24} />
            </div>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
          </Upload.Dragger>
        </Form.Item>
      </Column>
    </Row>
  </Form>
);

export const ESSSTPRReportUploadModal = ({
  isVisible,
  handleOk,
  handleCancel,
  parentId,
}) => {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const [uploadESSSTPRFile] = useMutation(CREATE_ESS_STPR_FILE);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(loading);

  useEffect(() => {
    if (isVisible) {
      form.resetFields();
      setLoading(false);
    }
  }, [isVisible]);

  const onFormSubmit = async () => {
    try {
      setLoading(true);

      const { link } = form.getFieldsValue();
      const uploadedFiles = [];
      let parentName = null;
      let parentIdToUse = parentId;

      handleCancel();

      for (const item of link) {
        const { newFile } = await imageUploader({ file: item });

        const { data } = await uploadESSSTPRFile({
          variables: {
            parentId: parentIdToUse,
            link: newFile.name,
            name: item.name,
          },
          notifyOnNetworkStatusChange: true,
        });

        const { id } = data.createESSSTPRFile;

        if (!parentName) {
          parentName = data.createESSSTPRFile.parentName;
        }

        if (!parentIdToUse) {
          parentIdToUse = data.createCRMIFile.parentId;
        }

        uploadedFiles.push({
          link: newFile.name,
          name: item.name,
          parentId: parentIdToUse,
          id,
        });

        Notification.success({
          message: `${item.name} uploaded successfully!`,
        });
      }

      setLoading(false);
      form.resetFields();
      handleOk(uploadedFiles, { parentName, parentId: parentIdToUse });
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });

      handleCancel();
    }
  };

  return (
    <>
      <Modal
        title="Upload Report"
        visible={isVisible}
        onOk={onFormSubmit}
        onCancel={handleCancel}
        centered
        width={720}
        footer={[
          <Button
            key="submit"
            loading={loading}
            type="primary"
            onClick={onFormSubmit}
            className="ml-auto"
            icon={<Icon name="plus" size={14} color="#fff" />}
          >
            Save
          </Button>,
        ]}
      >
        <ReportUploadForm formInstance={form} />
      </Modal>
      <Alert
        showDialog={showPrompt}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
      />
    </>
  );
};

ReportUploadForm.defaultProps = {
  formInstance: {
    setFieldsValue: () => {},
  },
  summaryReport: false,
};

ReportUploadForm.propTypes = {
  formInstance: PropTypes.shape({
    setFieldsValue: PropTypes.func,
  }),
  summaryReport: PropTypes.bool,
};

ESSSTPRReportUploadModal.defaultProps = {
  isVisible: false,
  handleOk: () => {},
  handleCancel: () => {},
  parentId: null,
};

ESSSTPRReportUploadModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  parentId: PropTypes.string,
};

export default ESSSTPRReportUploadModal;
